import { Flex } from 'antd';
import styled from 'styled-components';

export const CardContainer = styled(Flex)`
  padding: 10px;
  border-radius: 5px;
  width: 100%;
  height: 100%;
  cursor: pointer;
  .icon {
    color: var(--clr-general-description);
    flex-shrink: 0;
  }
`;

export const CalendarWrapper = styled.div`
  height: calc(var(--viewport-height) - 234px);
  padding-bottom: 15px;
  .rbc-calendar {
    --current-time-pill-width: 38px;
    --current-time-dot-size: 5px;
    --current-time-inset: calc(var(--current-time-pill-width) + var(--current-time-dot-size) + 5px);
    .rbc-time-view {
      border: none;
      .rbc-time-header {
        display: none;
      }
      .rbc-time-content {
        --gutter-label-height: 24px;
        border-top: 0;
        padding-top: calc(var(--gutter-label-height) / 2);
        /* With no entries the browser makes this scroller a tab stop itself, with its default ring. */
        &:focus-visible {
          outline: 2px solid var(--clr-general-primary);
          outline-offset: -2px;
        }
        .rbc-time-gutter {
          transform: translateY(calc(var(--gutter-label-height) / -2));
          min-width: var(--current-time-inset);
          .rbc-timeslot-group {
            border-bottom: 0;
            text-align: left;
          }
        }
        .rbc-label {
          padding-inline: 0 10px;
          font-size: 13px;
          font-weight: 500;
          line-height: var(--gutter-label-height);
          color: var(--clr-title);
        }
        .rbc-timeslot-group {
          min-height: 70px;
          border-bottom-color: transparent;
          .rbc-time-slot {
            border-color: var(--clr-border-grey-100);
          }
        }
        .rbc-events-container {
          margin-right: 0;
        }
        & > * + * > * {
          border-left-color: var(--clr-border-grey-100);
        }
        .rbc-day-slot {
          .rbc-event {
            border: none;
            padding: 0 2px;
            min-height: 36px;
            background-color: transparent;
            &:has(.event-input) {
              padding-block: 4px;
            }
            .rbc-event-label {
              display: none;
            }
          }
          &.rbc-today {
            background-color: transparent;
          }
        }
      }
    }
    .rbc-slot-selection {
      background: rgba(var(--clr-general-primary-rgb), 0.2) !important;
      span {
        color: var(--clr-title);
      }
    }
    .rbc-current-time-indicator {
      background-color: transparent;
      left: calc(-1 * var(--current-time-inset));
      .current-time {
        width: var(--current-time-pill-width);
        padding-inline: 4px;
        border-radius: 20px;
        background-color: var(--clr-general-primary);
        color: var(--clr-white);
        font-size: 11px;
        font-weight: 500;
        text-align: center;
        line-height: 18px;
        height: 17px;
        display: block;
      }
      &::before {
        content: '';
        width: var(--current-time-dot-size);
        height: var(--current-time-dot-size);
        border-radius: 50px;
        background-color: var(--clr-general-primary);
        display: block;
        position: absolute;
        left: var(--current-time-pill-width);
        top: -2px;
      }
      &::after {
        content: '';
        position: absolute;
        left: calc(var(--current-time-pill-width) + var(--current-time-dot-size));
        right: 0;
        top: 0;
        height: 1px;
        background-color: var(--clr-general-primary);
      }
    }
  }
`;

export const AgendaTimeWrapper = styled(Flex)`
  width: 100%;
  max-width: 45px;
`;

export const EditWrapper = styled.div`
  .event-input-note {
    position: absolute;
    left: 7px;
    bottom: 6px;
  }
`;
